import type { ReactNode } from 'react';
import type { ApiLanguage } from '@luacentrix/shared';
import { Alert, Button, Skeleton } from '@luacentrix/ui';
import { describeError } from '../data/api';

export interface QueryBoundaryProps {
  isPending: boolean;
  isError: boolean;
  error: unknown;
  language: ApiLanguage;
  onRetry: () => void;
  retrying: boolean;
  rows?: number;
  children: ReactNode;
}

export function QueryBoundary({
  isPending,
  isError,
  error,
  language,
  onRetry,
  retrying,
  rows = 4,
  children,
}: QueryBoundaryProps) {
  if (isPending) {
    return (
      <div className="lc-stack">
        {Array.from({ length: rows }, (_, index) => (
          <Skeleton key={index} height={16} />
        ))}
      </div>
    );
  }

  if (isError) {
    const presentation = describeError(error, language);
    return (
      <Alert
        tone="danger"
        title={`${presentation.code}${presentation.status === null ? '' : ` · HTTP ${presentation.status}`}`}
        action={
          <Button size="sm" icon="refresh" loading={retrying} onClick={onRetry}>
            Retry
          </Button>
        }
      >
        {presentation.message}
        {presentation.field === null ? '' : ` Field: ${presentation.field}.`}
      </Alert>
    );
  }

  return <>{children}</>;
}
